const PayInInstalmentIcon = ({ width = 24, height = 24, fill = "#011851" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.4"
      d="M3.59998 6.59995C3.59998 5.6062 4.40623 4.79995 5.39998 4.79995H19.8C20.13 4.79995 20.4 4.52995 20.4 4.19995V6.59995C19.8975 6.2212 19.275 5.99995 18.6 5.99995H6.59998C6.26998 5.99995 5.99998 6.26995 5.99998 6.59995C5.99998 6.92995 6.26998 7.19995 6.59998 7.19995H18.6C19.5937 7.19995 20.4 8.0062 20.4 8.99995V16.2C20.4 17.1937 19.5937 18 18.6 18H5.39998C4.40623 18 3.59998 17.1937 3.59998 16.2V6.59995ZM15.9 12.6C15.9 13.0987 16.3012 13.5 16.8 13.5C17.2987 13.5 17.7 13.0987 17.7 12.6C17.7 12.1012 17.2987 11.7 16.8 11.7C16.3012 11.7 15.9 12.1012 15.9 12.6Z"
      fill={fill}
      fillOpacity="0.5"
    />
    <path
      d="M5.40002 3.6001C3.74252 3.6001 2.40002 4.9426 2.40002 6.6001V16.2001C2.40002 17.8576 3.74252 19.2001 5.40002 19.2001H18.6C20.2575 19.2001 21.6 17.8576 21.6 16.2001V9.0001C21.6 7.3426 20.2575 6.0001 18.6 6.0001H6.60002C6.27002 6.0001 6.00002 6.2701 6.00002 6.6001C6.00002 6.9301 6.27002 7.2001 6.60002 7.2001H18.6C19.5938 7.2001 20.4 8.00635 20.4 9.0001V16.2001C20.4 17.1938 19.5938 18.0001 18.6 18.0001H5.40002C4.40627 18.0001 3.60002 17.1938 3.60002 16.2001V6.6001C3.60002 5.60635 4.40627 4.8001 5.40002 4.8001H19.8C20.13 4.8001 20.4 4.5301 20.4 4.2001C20.4 3.8701 20.13 3.6001 19.8 3.6001H5.40002ZM16.8 13.5001C17.2988 13.5001 17.7 13.0988 17.7 12.6001C17.7 12.1013 17.2988 11.7001 16.8 11.7001C16.3013 11.7001 15.9 12.1013 15.9 12.6001C15.9 13.0988 16.3013 13.5001 16.8 13.5001Z"
      fill={fill}
    />
  </svg>
);

export default PayInInstalmentIcon;
